import { render, staticRenderFns } from "./hospitalArea.vue?vue&type=template&id=41fd357e&scoped=true"
var script = {}
import style0 from "./hospitalArea.vue?vue&type=style&index=0&id=41fd357e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd357e",
  null
  
)

export default component.exports